import { LoadFile } from './LoadFile';
import { LoadCurve } from './LoadCurve';
import { LoadEnergyEfficiency } from './LoadEnergyEfficiency';
import { LoadProfile } from './LoadProfile';
import assignToThis from '../../helper/assignToThis';
import { ObjectOnly } from '@/classes/ObjectOnly';

export class ScenarioLoad {

  // it would be nice to have this as a get only accessor (evaluating file and profile)
  // but it would not be serialized by JSON.stringify... TypeScript not ready ? ;-)
  public hasUploadedLoad: boolean | null = null;

  public file: LoadFile | null = null;

  public profile: LoadProfile | null = null;

  public calculatedCurveBefore: LoadCurve | null = null;
  public calculatedCurveAfter: LoadCurve | null = null;

  public hasEnergyEfficiency: boolean | null = null;
  public energyEfficiency: LoadEnergyEfficiency | null = null;

  public hasAdditionalConsumptionFromPVSystemAncillaryServices: boolean | null = null;

  // replaces consumptionChangeKwhd (consumption are positive changes)
  public additionalConsumptionPerDay: number | null = null;

  // fixed at 0.8 in the algorithm - may appear as an info to the user (the user will not be able to modify it)
  public loadPowerFactor: number | null = null;

  public constructor(obj: ObjectOnly = {}) {
    assignToThis(this, obj);

    this.file = this.file ? new LoadFile(this.file) : null;

    this.profile = this.profile ? new LoadProfile(this.profile) : null;

    this.calculatedCurveBefore = this.calculatedCurveBefore ? new LoadCurve(this.calculatedCurveBefore) : null;
    this.calculatedCurveAfter = this.calculatedCurveAfter ? new LoadCurve(this.calculatedCurveAfter) : null;

    this.energyEfficiency = this.energyEfficiency ? new LoadEnergyEfficiency(this.energyEfficiency) : null;
  }

}
